import { createFileRoute } from "@tanstack/react-router";
import { PolicyPage, policyHead } from "../pages/PolicyPage";

export const Route = createFileRoute("/terms-of-service")({
  head: () => policyHead("terms"),
  component: () => <PolicyPage page="terms" />
});
